module.exports = __webpack_public_path__ + "img/apple_store.1caa7d3.png";